/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import styled from 'styled-components';
import { Droppable } from 'react-beautiful-dnd';
import PropTypes from 'prop-types';
import Item from './CoursePlanRessourceItem';

function CardBook(props) {
  const {
    toDo,
    checked,
    handleToggle,
    optionLabel,
    suggested,
    setSuggested,
  } = props;
  const StyledContainer = styled.div``;
  const taskHendler = (items) => items.map((item, index) => (
    <Item
      index={index}
      optionLabel={optionLabel}
      handleToggle={handleToggle}
      checked={checked}
      item={item}
      suggested={suggested}
      setSuggested={setSuggested}
    />
  ));
  return (
    <Droppable droppableId="4">
      {(provided) => (
        <StyledContainer
          ref={provided.innerRef}
          {...provided.droppableProps}
        >
          {taskHendler(toDo)}
          {provided.placeholder}
        </StyledContainer>
      )}
    </Droppable>
  );
}

CardBook.propTypes = {
  toDo: PropTypes.any.isRequired,
  checked: PropTypes.any.isRequired,
  handleToggle: PropTypes.any.isRequired,
  optionLabel: PropTypes.any.isRequired,
  suggested: PropTypes.any.isRequired,
  setSuggested: PropTypes.any.isRequired,
};

export default CardBook;
